import React from 'react';
import { TrackingSourceEnum } from '../types';
import { MobileAppLocationMarkerPopup } from './mobile-app-location-marker-popup';
export const renderTrackingLocationMarkerPopup = (props) => {
    const { location, locationSourceMetadata, sequence, source } = props;
    switch (source) {
        case TrackingSourceEnum.MobileApp:
            return (React.createElement(MobileAppLocationMarkerPopup, { location: location, locationSourceMetadata: locationSourceMetadata, sequence: sequence }));
        case TrackingSourceEnum.ELD:
            return 'ELD';
        default:
            return null;
    }
};
